import { render } from "./vphotoidedit.vue?vue&type=template&id=7521b7c1&scoped=true"
import script from "./vphotoidedit.vue?vue&type=script&lang=js"
export * from "./vphotoidedit.vue?vue&type=script&lang=js"

import "./vphotoidedit.vue?vue&type=style&index=0&id=7521b7c1&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7521b7c1"]])

export default __exports__